"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPendingChangeDto = instanceOfPendingChangeDto;
exports.PendingChangeDtoFromJSON = PendingChangeDtoFromJSON;
exports.PendingChangeDtoFromJSONTyped = PendingChangeDtoFromJSONTyped;
exports.PendingChangeDtoToJSON = PendingChangeDtoToJSON;
exports.PendingChangeDtoToJSONTyped = PendingChangeDtoToJSONTyped;
/**
 * Check if a given object implements the PendingChangeDto interface.
 */
function instanceOfPendingChangeDto(value) {
    if (!('planCode' in value) || value['planCode'] === undefined)
        return false;
    if (!('effectiveAt' in value) || value['effectiveAt'] === undefined)
        return false;
    return true;
}
function PendingChangeDtoFromJSON(json) {
    return PendingChangeDtoFromJSONTyped(json, false);
}
function PendingChangeDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'planCode': json['planCode'],
        'effectiveAt': json['effectiveAt'],
    };
}
function PendingChangeDtoToJSON(json) {
    return PendingChangeDtoToJSONTyped(json, false);
}
function PendingChangeDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'planCode': value['planCode'],
        'effectiveAt': value['effectiveAt'],
    };
}
